// extracted by mini-css-extract-plugin
export var richtext = "styles-module--richtext--e44f0";